import { Fragment, useEffect, useRef, useState } from "react";
import { RouteComponentProps } from "../../models/RouteComponent";
import { TabView, TabPanel } from "primereact/tabview";
import { Card } from "primereact/card";
import { InputText } from "primereact/inputtext";

import { Grid } from "@mui/material";
import { FormControl, FormLabel, Input } from "@mui/joy";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { PhoneInput } from "react-international-phone";
import { AlternateEmailOutlined } from "@mui/icons-material";

import S3DocumentsUpload from "../../components/S3DocumentsUpload";

import { updateEmployee } from "../../service/employeeService";
import MultiDropdownApi from "../../components/MultiDropdownApi";
import ImageS3Upload from "../../components/ImageS3Upload";
import { v4 } from "uuid";

import { apiGet, NprLookup } from "../../service/api-service";
import EmployeeQrCode from "../../components/EmployeeQrCode";

import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { USAGE_TYPE_ENUM } from "../billing/common";
import ProfileSignature from "../../components/Signature";
import EmployeeDocumentsSignedTable from "./Employee-Documents-Signed-table";
import {
  s3GetUrl,
  s3GetUrlBase64,
  s3UploadFileImage,
  s3UploadObjectUrl,
} from "../../service/s3Service";
import { Dropdown } from "primereact/dropdown";
import EmployeeSiteTable from "./Site/Employee-Site-table";
import EmployeePPETable from "./PPE/Employee-PPE-table";

import HomeAffairsView from "./Home-Affairs/Home-Affairs-View";

export default function EmployeeView(props: RouteComponentProps) {
  const employee = props.employee || {};

  const [data, setData] = useState({} as any);
  const [businessNature, setBusinessNature] = useState("");
  const [consultant, setConsultant] = useState("");
  const [consultantName, setConsultantName] = useState("");
  const [contactPerson, setContactPerson] = useState("");
  const [email, setEmail] = useState(employee.email);
  const [fundRegistrationNumber, setFundRegistrationNumber] = useState("");
  const [industry, setIndustry] = useState("");
  const [mobile, setMobile] = useState(employee.mobile || "");
  const [enrolment, setEnrolment] = useState(employee.active);
  const [name, setName] = useState(employee.name);
  const [surname, setSurname] = useState(employee.surname);
  const [idNumber, setIdNumber] = useState<string>(employee.id_number);
  const [title, setTitle] = useState(employee.title);
  const [siteData, setSiteData] = useState<any[]>(employee.site_data || []);
  const [physicalAddress, setPhysicalAddress] = useState("");
  const [photo, setPhoto] = useState(employee.photo);
  const [dateOfDeath, setDateOfDeath] = useState(employee?.date_of_death || "");
  const [dateOfMarriage, setDateOfMarriage] = useState(employee?.date_of_marriage || "");
  const [dateTimeOfMarriage, setDateTimeOfMarriage] = useState(
    employee?.date_time_of_marriage || ""
  );
  const [deadIndicator, setDeadIndicator] = useState(employee?.dead_indicator || "");
  const [idBlocked, setIdBlocked] = useState(employee?.id_blocked || "");
  const [birthPlaceCountry, setBirthPlaceCountry] = useState(employee?.birth_place_country || "");
  const [birthPlaceCountryCode, setBirthPlaceCountryCode] = useState(
    employee?.birth_place_country_code || ""
  );
  const [idIssueDate, setIdIssueDate] = useState(employee?.id_issue_date || "");
  const [maritalStatus, setMaritalStatus] = useState(employee?.marital_status || "");
  const [photoGuid, setPhotoGuid] = useState(employee?.photo_guid || "");
  const [smartCardIssued, setSmartCardIssued] = useState(employee?.smart_card_issued || false);
  const [transactionNo, setTransactionNo] = useState(employee?.transaction_no || "");
  const [loading, setLoading] = useState(false);
  const [nprLookup, setNprLookup] = useState(employee?.npr_lookup || false);
  const [file, setFile] = useState<File>();
  const [appointment, setAppointment] = useState(employee.appointment);
  const [validID, setValidID] = useState(false);
  const [nprLookupPrice, setNprLookupPrice] = useState("0");
  const toast = useRef(null as any);
  const [signatureS3Key, setSignatureS3Key] = useState<string | null>(employee.signature_s3_key);
  const [signatureInitialS3Url, setSignatureInitialS3Url] = useState<string | null>(null);
  const [signature, setSignature] = useState<string | null>(null); //ObjectURL (Image base64), set if new signature
  const [signatureChanged, setSignatureChanged] = useState<boolean>(false);
  const [department, setDepartment] = useState(employee.department);
  const [employeeNumber, setEmployeeNumber] = useState(employee?.employee_number || "");
  const [nextOfKinName, setNextOfKinName] = useState(employee?.next_of_kin_name || "");
  const [nextOfKinSurname, setNextOfKinSurname] = useState(employee?.next_of_kin_surname || "");
  const [nextOfKinCell, setNextOfKinCell] = useState(employee?.next_of_kin_cell || "");
  const [nextOfKinEmail, setNextOfKinEmail] = useState(employee?.next_of_kin_email || "");
  const [gender, setGender] = useState(employee?.gender || "");

  const genders = [{ name: "Male" }, { name: "Female" }];

  const session = props?.session || {};

  const clientId = session.client_id;
  const s3Key = employee?.s3_key || `employee/profile/${employee.id}`;
  const siteId = session?.site_id;

  console.log("employee", employee);

  // const client = props.

  useEffect(() => {
    setUpdateS3Key();
  }, [file]);

  useEffect(() => {
    if (!idNumber) return setValidID(false);
    if (idNumber.length != 13) return setValidID(false);
    if (idNumber.match(/^[0-9]+$/) == null) return setValidID(false);
    return setValidID(true);
  }, [idNumber]);

  async function setS3KeyToUrl() {
    console.log("signatureS3Key", signatureS3Key);
    if (!signatureS3Key) return;

    const s3Url = await s3GetUrl(signatureS3Key);
    setSignatureInitialS3Url(s3Url);
    console.log("s3Url", s3Url);
  }
  useEffect(() => {
    setS3KeyToUrl();
  }, [signatureS3Key]);

  async function setUpdateS3Key() {
    updateEmployee(
      {
        s3_key: s3Key,
      },
      employee.id
    ).then((r: any) => { });
  }

  async function EmployeeVerifyID() {
    props.setGlobalLoader(true);
    NprLookup(idNumber)
      .then((r: any) => {
        if (!r.idNumber) {
          toast.current.show({
            severity: "error",
            summary: "Invalid ID Number",
            life: 3000,
          });
          return;
        }
        toast.current.show({
          severity: "success",
          summary: "Valid ID Number",
          life: 3000,
        });
        setNprLookup(true);
        setFile(undefined);
        setName(r.name);
        setSurname(r.surname);
        setPhoto(r.photo);
        setDateOfDeath(r.dateOfDeath);
        setDateOfMarriage(r.dateOfMarriage);
        setDateTimeOfMarriage(r.dateTimeOfMarriage);
        setDeadIndicator(r.deadIndicator);
        setIdBlocked(r.idBlocked);
        setIdIssueDate(r.idIssueDate);
        setMaritalStatus(r.maritalStatus);
        setBirthPlaceCountry(r.birthPlaceCountry);
        setBirthPlaceCountryCode(r.birthPlaceCountryCode);
        setPhotoGuid(r.photoGuid);
        setSmartCardIssued(r.smartCardIssued);
        setTransactionNo(r.transactionNo);
        updateConsultant();
      })
      .catch(error => {
        console.log("EmployeeVerifyID error == ", error);
      })
      .finally(() => {
        props.setGlobalLoader(false);
      });
  }

  async function getPricingData() {
    try {
      const response = await apiGet("core", "billing/pricing");
      const prices = response.content || [];
      const activeNPRLookup = prices.find(
        (e: any) => e.active && e.usage_type == USAGE_TYPE_ENUM.Home_Affairs_Lookup
      );
      if (activeNPRLookup?.id) {
        setNprLookupPrice(parseFloat(activeNPRLookup.cost_client_per_unit).toFixed(2));
      }
      console.log("Pricing data:", prices);
    } catch (error) {
      console.error("Error fetching pricing data:", error);
    } finally {
    }
  }

  useEffect(() => {
    getPricingData();
    setS3KeyToUrl();
  }, []);

  const confirm = () => {
    confirmDialog({
      message: `Please note ID Number verification Cost R${nprLookupPrice} Per Lookup Are you sure you want to proceed?`,
      header: "Home Affairs Verification",
      icon: "pi pi-exclamation-triangle",
      defaultFocus: "accept",
      accept: () => {
        EmployeeVerifyID();
      },
    });
  };

  async function updateConsultant() {
    let signatureS3Key = null;
    if (signatureChanged && signature) {
      signatureS3Key = `employee/signature/${employee.id}/${v4()}`;
      await s3UploadObjectUrl(signatureS3Key, signature);
    }

    let updateObject: any = {
      name: name,
      surname,
      appointment,
      email: email,
      mobile: mobile,
      title,
      id_number: idNumber,
      npr_lookup: nprLookup,
      department,
      employee_number: employeeNumber,
      next_of_kin_name: nextOfKinName,
      next_of_kin_surname: nextOfKinSurname,
      next_of_kin_cell: nextOfKinCell,
      next_of_kin_email: nextOfKinEmail,
      gender,
    };
    if (signatureChanged) updateObject["signature_s3_key"] = signatureS3Key;

    updateEmployee(updateObject, employee.id).then((r: any) => {
      toast.current.show({
        severity: "success",
        summary: "Employee Updated Successfully",
        life: 3000,
      });
    });
  }

  const record_id = employee.id || "";

  const path = `employee/${employee.id}/enrolment/profile`;

  async function onSignatureChange(signature: string | null) {
    setSignatureChanged(true);
    setSignature(signature);
  }

  useEffect(() => {
    if (employee?.s3_key) {
      s3GetUrlBase64(employee.s3_key).then(url => {
        setPhoto(url);
        // console.log("url == ", url);
      });
    }
  }, [employee?.s3_key]);

  return (
    <Fragment>
      <ConfirmDialog />
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          gap: "1rem",
          margin: "1rem 0 0",
        }}
      >
        <Button
          type="button"
          icon="pi pi-verified"
          label="Verify ID"
          disabled={!validID}
          className="p-button-outlined"
          size="small"
          style={{ fontSize: "small" }}
          onClick={() => confirm()}
        />

        <Button
          type="button"
          icon="pi pi-save"
          label="Save"
          className="p-button-outlined"
          size="small"
          style={{
            fontSize: "small",
            color: "#2dd36f",
          }}
          onClick={() => updateConsultant()}
        />
      </div>
      <TabView>
        <TabPanel header="Employee Details">
          <Card>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <ImageS3Upload photo={photo} setPhoto={setPhoto} s3Key={s3Key} toast={toast} />
              </Grid>
              <Grid item xs={6}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <FormLabel style={{ marginBottom: 10 }}>ID Number</FormLabel>
                    <FormControl
                      sx={{
                        display: { sm: "flex-column", md: "flex-row" },
                        gap: 2,
                      }}
                    >
                      <InputText
                        value={idNumber}
                        onChange={e => setIdNumber(e.target.value)}
                        type="text"
                        className="p-inputtext-sm PrimeSmallInput"
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12}>
                    <FormControl sx={{ display: { sm: "flex-column", md: "flex-row" } }}>
                      <FormLabel style={{ marginBottom: 10 }}>Employee Number</FormLabel>
                      <InputText
                        value={employeeNumber}
                        onChange={e => setEmployeeNumber(e.target.value)}
                        type="text"
                        className="p-inputtext-sm PrimeSmallInput"
                        placeholder="Please enter Employee Number"
                      />
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={6}>
                <FormLabel style={{ marginBottom: 10 }}>Name</FormLabel>
                <FormControl
                  sx={{
                    display: { sm: "flex-column", md: "flex-row" },
                    gap: 2,
                  }}
                >
                  <InputText
                    value={name}
                    onChange={e => setName(e.target.value)}
                    type="text"
                    className="p-inputtext-sm PrimeSmallInput"
                    placeholder="Please enter name"
                  />
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <FormLabel style={{ marginBottom: 10 }}>Surname</FormLabel>
                <FormControl
                  sx={{
                    display: { sm: "flex-column", md: "flex-row" },
                    gap: 2,
                  }}
                >
                  <InputText
                    value={surname}
                    onChange={e => setSurname(e.target.value)}
                    type="text"
                    className="p-inputtext-sm PrimeSmallInput"
                    placeholder="Please enter surname"
                  />
                </FormControl>
              </Grid>

              <Grid item xs={6}>
                <FormLabel style={{ marginBottom: 10 }}>Job Title</FormLabel>
                <FormControl
                  sx={{
                    display: { sm: "flex-column", md: "flex-row" },
                    gap: 2,
                  }}
                >
                  <InputText
                    value={title}
                    onChange={e => setTitle(e.target.value)}
                    type="text"
                    className="p-inputtext-sm PrimeSmallInput"
                    placeholder="Please enter title"
                  />
                </FormControl>
              </Grid>

              <Grid item xs={6}>
                <FormLabel style={{ marginBottom: 10 }}>Department</FormLabel>
                <FormControl
                  sx={{
                    display: { sm: "flex-column", md: "flex-row" },
                    gap: 2,
                  }}
                >
                  <InputText
                    value={department}
                    onChange={e => setDepartment(e.target.value)}
                    type="text"
                    className="p-inputtext-sm PrimeSmallInput"
                    placeholder="Please enter title"
                  />
                </FormControl>
              </Grid>

              <Grid item xs={6}>
                <MultiDropdownApi
                  apiPath="appointments"
                  optionLabel="name"
                  optionValue="id"
                  label="Appointment"
                  selectedData={appointment}
                  setSelectedData={setAppointment}
                />
              </Grid>
              <Grid item xs={6}>
                <FormControl sx={{ display: { sm: "flex-column", md: "flex-row" } }}>
                  <FormLabel style={{ marginBottom: 10 }}>Gender</FormLabel>
                  <Dropdown
                    className="PrimeSmallInput custom-dropdown"
                    style={{ fontSize: "small", padding: 0 }}
                    onChange={(e: any) => setGender(e.value)}
                    value={gender}
                    options={genders}
                    optionLabel="name"
                    optionValue="name"
                    filter
                    showClear
                    filterBy="name"
                    placeholder={`Select a Gender`}
                    panelClassName="custom-dropdown-panel"
                  />
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <FormLabel style={{ marginBottom: 10 }}>Mobile</FormLabel>
                <FormControl
                  sx={{
                    display: { sm: "flex-column", md: "flex-row" },
                    gap: 2,
                  }}
                >
                  <PhoneInput
                    defaultCountry="za"
                    value={mobile}
                    onChange={e => setMobile(e)}
                    inputStyle={{ width: "100%" }}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <FormLabel style={{ marginBottom: 10 }}>Email</FormLabel>
                <FormControl
                  sx={{
                    display: { sm: "flex-column", md: "flex-row" },
                    gap: 2,
                  }}
                >
                  <div className="p-inputgroup ">
                    <span className="p-inputgroup-addon PrimeSmallInput">
                      <AlternateEmailOutlined />
                    </span>
                    <InputText
                      style={{ width: "100%" }}
                      value={email}
                      onChange={e => setEmail(e.target.value)}
                      type="text"
                      className="p-inputtext-sm PrimeSmallInput"
                      placeholder="Please email"
                    />
                  </div>
                </FormControl>
              </Grid>

              <Grid item xs={6}>
                <FormControl sx={{ display: { sm: "flex-column", md: "flex-row" } }}>
                  <FormLabel style={{ marginBottom: 10 }}>Next Of Kin Name</FormLabel>
                  <InputText
                    value={nextOfKinName}
                    onChange={e => setNextOfKinName(e.target.value)}
                    type="text"
                    className="p-inputtext-sm PrimeSmallInput"
                    placeholder="Please enter name"
                  />
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <FormControl sx={{ display: { sm: "flex-column", md: "flex-row" } }}>
                  <FormLabel style={{ marginBottom: 10 }}>Next Of Kin Surname</FormLabel>
                  <InputText
                    value={nextOfKinSurname}
                    onChange={e => setNextOfKinSurname(e.target.value)}
                    type="text"
                    className="p-inputtext-sm PrimeSmallInput"
                    placeholder="Please enter surname"
                  />
                </FormControl>
              </Grid>

              <Grid item xs={6}>
                <FormControl sx={{ display: { sm: "flex-column", md: "flex-row" } }}>
                  <FormLabel style={{ marginBottom: 10 }}>Next Of Kin Mobile</FormLabel>
                  <PhoneInput
                    defaultCountry="za"
                    value={nextOfKinCell}
                    onChange={e => setNextOfKinCell(e)}
                    inputStyle={{ width: "100%" }}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <FormControl sx={{ display: { sm: "flex-column", md: "flex-row" } }}>
                  <FormLabel style={{ marginBottom: 10 }}>Next Of Kin Email</FormLabel>
                  <div className="p-inputgroup ">
                    <span className="p-inputgroup-addon PrimeSmallInput">
                      <AlternateEmailOutlined />
                    </span>
                    <InputText
                      style={{ width: "100%" }}
                      value={nextOfKinEmail}
                      onChange={e => setNextOfKinEmail(e.target.value)}
                      type="text"
                      className="p-inputtext-sm PrimeSmallInput"
                      placeholder="Please email"
                    />
                  </div>
                </FormControl>
              </Grid>

              <Grid item xs={6}>
                <FormLabel style={{ marginBottom: 10 }}>Signature</FormLabel>
                <ProfileSignature
                  initialSignature={signatureInitialS3Url}
                  onSignatureChange={onSignatureChange}
                />
              </Grid>
            </Grid>
          </Card>
        </TabPanel>
        {!siteId && employee?.npr_lookup && (
          <TabPanel header="Home Affairs">
            <HomeAffairsView
              details={{
                idNumber,
                name,
                surname,
                dateOfDeath,
                dateOfMarriage,
                dateTimeOfMarriage,
                deadIndicator,
                idBlocked,
                idIssueDate,
                maritalStatus,
                birthPlaceCountry,
                birthPlaceCountryCode,
                photoGuid,
                smartCardIssued,
                transactionNo,
                searchedDate: employee?.updated_at,
              }}
              image={`https://cdn.openitem.app/?url=https://accesscontrol.openitemapp.com/Photos/Image?photoguid=${photoGuid}`}
            />
            {/* <Card header={HomeAffairCardHeader}>
                <div style={{ padding: 20 }} ref={elementRef}>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <FormControl>
                        <Avatar
                          style={{ width: 150, height: 150, margin: "auto" }}
                          image={`https://cdn.openitem.app/?url=https://accesscontrol.openitemapp.com/Photos/Image?photoguid=${photoGuid}`}
                          shape="circle"
                        />
                      </FormControl>
                    </Grid>
                    <Grid item xs={6}>
                      <Grid item xs={12}>
                        <FormControl>
                          <FormLabel>ID Blocked</FormLabel>
                          <Input
                            size="sm"
                            placeholder="Id Blocked"
                            value={idBlocked}
                            style={{ width: "100%" }}
                            readOnly
                            sx={{ flexGrow: 1 }}
                          />
                        </FormControl>
                      </Grid>
                      <br />
                      <Grid item xs={12}>
                        <FormControl sx={{ flexGrow: 1 }}>
                          <FormLabel>Id Issue Date</FormLabel>
                          <Input
                            size="sm"
                            placeholder="Id Issue Date"
                            value={idIssueDate}
                            style={{ width: "100%" }}
                            readOnly
                            sx={{ flexGrow: 1 }}
                          />
                        </FormControl>
                      </Grid>
                    </Grid>

                    <Grid item xs={12}>
                      <FormControl>
                        <FormLabel>Full Name</FormLabel>
                        <Input
                          size="sm"
                          placeholder="IS Dead"
                          value={`${name} ${surname}`}
                          readOnly
                          sx={{ flexGrow: 1 }}
                        />
                      </FormControl>
                    </Grid>

                    <Grid item xs={6}>
                      <FormControl>
                        <FormLabel>IS Dead</FormLabel>
                        <Input
                          size="sm"
                          placeholder="IS Dead"
                          value={deadIndicator}
                          readOnly
                          sx={{ flexGrow: 1 }}
                        />
                      </FormControl>
                    </Grid>
                    <Grid item xs={6}>
                      <FormControl sx={{ flexGrow: 1 }}>
                        <FormLabel>Date Of Death</FormLabel>
                        <Input
                          size="sm"
                          placeholder="Date Of Death"
                          value={dateOfDeath}
                          readOnly
                          sx={{ flexGrow: 1 }}
                        />
                      </FormControl>
                    </Grid>

                    <Grid item xs={6}>
                      <FormControl>
                        <FormLabel>Marital Status</FormLabel>
                        <Input
                          size="sm"
                          placeholder="Marital Status"
                          value={maritalStatus}
                          readOnly
                          onChange={(e) => setEmail(e.target.value)}
                          sx={{ flexGrow: 1 }}
                        />
                      </FormControl>
                    </Grid>
                    <Grid item xs={6}>
                      <FormControl sx={{ flexGrow: 1 }}>
                        <FormLabel>Date Of Marriage</FormLabel>
                        <Input
                          size="sm"
                          placeholder="Date Of Marriage"
                          value={dateOfMarriage}
                          readOnly
                          onChange={(e) => setEmail(e.target.value)}
                          sx={{ flexGrow: 1 }}
                        />
                      </FormControl>
                    </Grid>
                    <Grid item xs={6}>
                      <FormControl>
                        <FormLabel>Birth Place Country</FormLabel>
                        <Input
                          size="sm"
                          placeholder="Birth Place Country"
                          value={birthPlaceCountry}
                          readOnly
                          sx={{ flexGrow: 1 }}
                        />
                      </FormControl>
                    </Grid>
                    <Grid item xs={6}>
                      <FormControl sx={{ flexGrow: 1 }}>
                        <FormLabel>Birth Place Country Code</FormLabel>
                        <Input
                          size="sm"
                          placeholder="Birth Place Country Code"
                          value={birthPlaceCountryCode}
                          readOnly
                          onChange={(e) => setEmail(e.target.value)}
                          sx={{ flexGrow: 1 }}
                        />
                      </FormControl>
                    </Grid>
                  </Grid>
                </div>
              </Card> */}
          </TabPanel>
        )}

        {!siteId && (
          <TabPanel header="Sites">
            <EmployeeSiteTable
              globalLoader={props.globalLoader}
              breadcrumbs={props.breadcrumbs}
              session={props.session}
              setBreadcrumbs={props.setBreadcrumbs}
              setGlobalLoader={props.setGlobalLoader}
              setSession={props.setSession}
              accessLevel={props.accessLevel}
              employee={employee}
              setAccessLevel={props.setAccessLevel}
              setEmployee={props.setEmployee}
            />
          </TabPanel>
        )}

        <TabPanel header="PPE">
          <EmployeePPETable
            globalLoader={props.globalLoader}
            breadcrumbs={props.breadcrumbs}
            session={props.session}
            setBreadcrumbs={props.setBreadcrumbs}
            setGlobalLoader={props.setGlobalLoader}
            setSession={props.setSession}
            accessLevel={props.accessLevel}
            employee={employee}
            setAccessLevel={props.setAccessLevel}
            setEmployee={props.setEmployee}
          />
        </TabPanel>

        <TabPanel header="Badge">
          <EmployeeQrCode
            label={`${name} ${surname}`}
            title={title}
            logo={session?.client_logo_s3_key || ""}
            value={`https://pwa.digitalsafetyfiles.com/employee/${employee?.id}`}
            image={
              photo ||
              `https://cdn.openitem.app/?url=https://accesscontrol.openitemapp.com/Photos/Image?photoguid=${photoGuid}`
            }
          />
        </TabPanel>
        <TabPanel header="Documents">
          <S3DocumentsUpload
            setGlobalLoader={props.setGlobalLoader}
            record_id={record_id}
            client_id={clientId}
            type="employee"
            props={props}
          />
        </TabPanel>
        <TabPanel header="Documents Signed">
          <EmployeeDocumentsSignedTable
            globalLoader={props.globalLoader}
            breadcrumbs={props.breadcrumbs}
            session={props.session}
            setBreadcrumbs={props.setBreadcrumbs}
            setGlobalLoader={props.setGlobalLoader}
            setSession={props.setSession}
            accessLevel={props.accessLevel}
            employee={employee}
            setAccessLevel={props.setAccessLevel}
            setEmployee={props.setEmployee}
          />
        </TabPanel>
        {/* <TabPanel header="Risk">
          <RiskAssessmentComponent setGlobalLoader={props.setGlobalLoader} record_id={record_id} client_id={clientId} type="Employee" props={props} />
        </TabPanel> */}
      </TabView>
      {/* nprLookup */}

      <Toast ref={toast} />
    </Fragment>
  );
}
